import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/cast.vue
var o = {
	name: "DtIconCast",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--cast"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Cast",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [...t[0] || (t[0] = [
		r("path", {
			fill: "currentColor",
			"fill-rule": "evenodd",
			d: "M2 2.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 1-1 0V3A1.5 1.5 0 0 1 2 1.5h8A1.5 1.5 0 0 1 11.5 3v6a1.5 1.5 0 0 1-1.5 1.5H7a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H2Z",
			"clip-rule": "evenodd"
		}, null, -1),
		r("path", {
			fill: "currentColor",
			"fill-rule": "evenodd",
			d: "M.503 5.947a.5.5 0 0 1 .55-.444 5 5 0 0 1 4.444 4.444.5.5 0 0 1-.994.106A4 4 0 0 0 .947 6.497a.5.5 0 0 1-.444-.55Z",
			"clip-rule": "evenodd"
		}, null, -1),
		r("path", {
			fill: "currentColor",
			"fill-rule": "evenodd",
			d: "M.508 7.908a.5.5 0 0 1 .584-.4 3 3 0 0 1 2.4 2.4.5.5 0 0 1-.984.184 2 2 0 0 0-1.6-1.6.5.5 0 0 1-.4-.584ZM.5 10a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H1a.5.5 0 0 1-.5-.5Z",
			"clip-rule": "evenodd"
		}, null, -1)
	])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=cast.js.map